module.exports = __webpack_public_path__ + "img/pr.1fe782a0.png";